import { flexBox } from 'common/styles/mixins'
import styled from 'styled-components'

export const Container = styled.div`
  ${flexBox('flex', 'unset', 'unset', 'column', 'unset')}
  width: 100%;
`
